import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { DeletedSectionsRefresh } from './deleted-section.action';
import { WFSectionLocalResource } from 'src/app/components/workflow/workflow';
import { ChecklistBuilderService } from '../../checklist-builder/checklist-builder.service';

export class DeletedSectionsStateModel {
  data: WFSectionLocalResource[] = [];
}

@State<DeletedSectionsStateModel>({
  name: 'DeletedWFSectionLocals',
  defaults: {
    data: [],
  },
})
@Injectable()
export class DeletedSectionsState extends BaseState {
  constructor(
    protected override injector: Injector, private service: ChecklistBuilderService
  ) {
    super(injector);
  }

  @Selector()
  static read(state: DeletedSectionsStateModel) {
    return state.data;
  }

  @Action(DeletedSectionsRefresh)
  refresh({ patchState }: StateContext<DeletedSectionsStateModel>, { checklistTemplateID }: DeletedSectionsRefresh) {
    this.service.getDeletedSections(checklistTemplateID).toPromise().then((data) => {
      patchState({ data });
    },
      (error) => console.error(error)
    );
  }

}
